import React from 'react';

import { Modal } from 'react-bootstrap';
import '../JobStageSummary.scss';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import { Loading } from '../../../_common';

interface RevertStagesModalProps {
    showRevertStageModal: boolean;
    jobStageIds: number[];
    handleOnClose: (modalType) => void;
    handleOnSave: (jobStageIds: any) => void;
    mutationLoading: boolean;
    modalError: string | undefined;
}

const RevertStagesModal = ({
    showRevertStageModal,
    jobStageIds,
    handleOnClose,
    handleOnSave,
    mutationLoading,
    modalError,
}: RevertStagesModalProps): React.ReactElement => {
    const onClickClose = () => {
        handleOnClose('revertStage');
    };

    return (
        <Modal show={showRevertStageModal} onHide={onClickClose} dialogClassName="AddStageModal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AddStageModal-Title">Revert Stages</div>
                    <div className="AddStageModal-Error">{modalError}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="Pause-Modal-Body">
                <div>Are you sure you want to revert the stage(s)?</div>
                <div>
                    <b>STATUS OF ALL ASSOCIATED STAGES WILL BE UPDATED AS &ldquo;RUNNING&ldquo;</b>
                </div>
            </Modal.Body>

            <Modal.Footer className="AddStageModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} isDisabled={mutationLoading} />
                <CustomButton title="Revert" onClick={() => handleOnSave(jobStageIds)} isDisabled={mutationLoading} />
            </Modal.Footer>
        </Modal>
    );
};

export default RevertStagesModal;
